import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";

export default function Orcamento() {
  return (
    <main>
      <Header />
      <section className="page-hero compact">
        <div className="site-container narrow">
          <span className="eyebrow light">Pedido de orçamento</span>
          <h1>Receba uma proposta adequada ao que precisa.</h1>
          <p>
            Quanto mais detalhes fornecer, mais precisa será a nossa análise de
            prazo, materiais e investimento.
          </p>
        </div>
      </section>
      <section className="section">
        <div className="site-container contact-layout">
          <div>
            <span className="eyebrow">Antes de enviar</span>
            <h2>Ajude-nos a compreender o projecto.</h2>
            <p>
              Indique a área, quantidade, formato, público, prazo e qualquer
              referência que considere importante.
            </p>
            <ol className="quote-steps">
              <li>
                <strong>Recepção</strong>
                <span>Confirmamos o seu pedido.</span>
              </li>
              <li>
                <strong>Análise</strong>
                <span>A equipa verifica requisitos e disponibilidade.</span>
              </li>
              <li>
                <strong>Proposta</strong>
                <span>Enviamos condições e próximos passos.</span>
              </li>
            </ol>
          </div>
          <ContactForm quote />
        </div>
      </section>
      <Footer />
    </main>
  );
}
